module.exports = __webpack_public_path__ + "img/brazil.afc791e4.svg";